import React, { useEffect, useState } from 'react';
import { database } from '../firebaseConfig';
import { ref, onValue } from 'firebase/database';

// Every email sent for a transaction, newest first. Opens from a button so it stays out of the way.
const TransactionCommunications = ({ transactionId }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!transactionId) return undefined;
    const unsub = onValue(ref(database, `transactions/${transactionId}/communications`), (snap) => {
      const val = snap.val() || {};
      const rows = Object.entries(val).map(([id, c]) => ({ id, ...c }))
        .sort((a, b) => String(b.sentAt || '').localeCompare(String(a.sentAt || '')));
      setItems(rows);
    }, (err) => console.error('Could not load communications', err));
    return () => unsub();
  }, [transactionId]);

  const when = (iso) => (iso ? new Date(iso).toLocaleString() : '');

  return (
    <div style={{ margin: '16px 0' }}>
      <button type="button" onClick={() => setOpen(!open)}
        style={{ background: '#fff', color: '#1a1a1a', border: '1px solid #d8c9a8', padding: '8px 14px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>
        {open ? 'Hide communications' : `Review communications (${items.length})`}
      </button>
      {open && (
        <div style={{ marginTop: 12 }}>
          {items.length === 0 && <p style={{ color: '#7f7f7f', fontSize: 14 }}>No emails have been sent for this transaction yet.</p>}
          {items.map((c) => (
            <div key={c.id} style={{ border: '1px solid #e7dfcc', borderRadius: 8, padding: 12, marginBottom: 8, background: '#fff' }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{c.subject || c.name || (c.kind === 'call' ? 'Phone call' : c.kind === 'text' ? 'Text message' : '')}</div>
              <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
                To {c.toName ? `${c.toName} ` : ''}{c.toEmail ? `<${c.toEmail}>` : (c.toPhone || '')} {c.role ? `(${c.role})` : ''} · {when(c.sentAt)} · {c.byName ? `by ${c.byName} · ` : ''}{c.status || ''}
              </div>
              <button type="button" onClick={() => setExpanded(expanded === c.id ? null : c.id)}
                style={{ marginTop: 6, background: 'none', border: 'none', color: '#8C6D1F', fontWeight: 600, cursor: 'pointer', padding: 0, fontSize: 13 }}>
                {expanded === c.id ? 'Hide message' : 'View message'}
              </button>
              {expanded === c.id && (
                c.kind === 'text' || c.kind === 'call' ? <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{c.body || ''}</div> : <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: c.body || '' }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TransactionCommunications;
